import { render, staticRenderFns } from "./klarna_pay.vue?vue&type=template&id=e9d82ac4&scoped=true&"
import script from "./klarna_pay.vue?vue&type=script&lang=js&"
export * from "./klarna_pay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d82ac4",
  null
  
)

export default component.exports